export enum EColors {
  PRIM1 = "#4B5597",
  PRIM2 = "#192261",
  ACC1_A = "#CDFFE6",
  ACC1_B = "#9DE4CC",
  ACC2_A = "#BC904F",
  ACC2_B = "#A43A18",
  WHITE = "#FFFFFF",
  DARK = "#141C54",
  DARK2 = "#51588d",
  GREY1 = "#F5F5F5",
  GREY2 = "#EFEFEF",
  GREY3 = "#E7E7E7",
  GREY4 = "#A9A9A9",
}

export enum EGrads {
  PRIM_GRAD = `linear-gradient(180deg, #4B5597 0%, #192261 100%)`,
  ACC1_GRAD = `linear-gradient(270deg, #9DE4CC 0%, #CDFFE6 100%)`,
  ACC2_GRAD = "linear-gradient(88.56deg, #BC904E 0%, #A33816 100%)",
  WHITE_GRAD = "linear-gradient(180deg, #EEEEEE 0%, #FFFFFF 95.91%)",
}

export enum EFonts {
  Medium = "CeraMedium",
  Bold = "CeraBold",
  Regular = "CeraRegular",
}

export enum EShadows {
  STRONG = "0px 10px 30px rgba(0, 0, 0, 0.3)",
  LIGHT = "0px 10px 20px rgba(0, 0, 0, 0.1)",
  VERY_LIGHT = "0px 10px 20px rgba(0, 0, 0, 0.05)",
}

export enum EHovers {
  LIGHT1 = "inset 0 0 100px 100px rgba(255, 255, 255, 0.05)",
  LIGHT2 = "inset 0 0 100px 100px rgba(255, 255, 255, 0.2)",
  DARK1 = "inset 0 0 100px 100px rgba(0, 0, 0, 0.03)",
}
